import { globalStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export default styled.span({
  fontSize: 44,
  lineHeight: '52px',
  color: globalStyles.colors.white,
  [mobileMediaQuery]: {
    fontSize: 32,
    lineHeight: '40px',
  },
});
